document.documentElement.classList.remove('no-js');

const closeLocalization = (root) => {
  const toggle = root.querySelector('[data-localization-toggle]');
  const panel = root.querySelector('[data-localization-panel]');
  toggle?.setAttribute('aria-expanded', 'false');
  panel?.setAttribute('hidden', '');
};

document.querySelectorAll('[data-localization]').forEach((root) => {
  const toggle = root.querySelector('[data-localization-toggle]');
  const panel = root.querySelector('[data-localization-panel]');
  const search = root.querySelector('[data-country-search]');
  const input = root.querySelector('[data-country-input]');

  toggle?.addEventListener('click', () => {
    const willOpen = panel.hasAttribute('hidden');
    document.querySelectorAll('[data-localization]').forEach((other) => {
      if (other !== root) closeLocalization(other);
    });
    panel.toggleAttribute('hidden', !willOpen);
    toggle.setAttribute('aria-expanded', String(willOpen));
    if (willOpen && search) setTimeout(() => search.focus(), 0);
  });

  search?.addEventListener('input', () => {
    const query = search.value.trim().toLocaleLowerCase();
    root.querySelectorAll('[data-country-item]').forEach((item) => {
      item.hidden = !item.dataset.countryName.toLocaleLowerCase().includes(query);
    });
  });

  root.querySelectorAll('[data-country-code]').forEach((option) => {
    option.addEventListener('click', () => {
      input.value = option.dataset.countryCode;
      root.closest('form')?.submit();
    });
  });

  root.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeLocalization(root);
      toggle?.focus();
    }
  });
});

document.addEventListener('click', (event) => {
  document.querySelectorAll('[data-localization]').forEach((root) => {
    if (!root.contains(event.target)) closeLocalization(root);
  });
});

document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-menu-toggle]');
  if (toggle) {
    const nav = document.querySelector('[data-mobile-nav]');
    const expanded = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!expanded));
    nav?.classList.toggle('is-open');
  }
});

document.querySelectorAll('[data-faq-button]').forEach((button) => {
  button.addEventListener('click', () => {
    const expanded = button.getAttribute('aria-expanded') === 'true';
    button.setAttribute('aria-expanded', String(!expanded));
    button.nextElementSibling.hidden = expanded;
  });
});

const initializeProductGallery = (gallery) => {
  if (gallery.dataset.galleryReady === 'true') return;
  gallery.dataset.galleryReady = 'true';

  const track = gallery.querySelector('[data-gallery-track]');
  const allSlides = [...gallery.querySelectorAll('[data-gallery-slide]')];
  const allDots = [...gallery.querySelectorAll('[data-gallery-dot]')];
  const controls = gallery.querySelector('[data-gallery-controls]');
  const previous = gallery.querySelector('[data-gallery-prev]');
  const next = gallery.querySelector('[data-gallery-next]');
  if (!track || !allSlides.length) return;

  let activeIndex = 0;
  let scrollTimer;
  let slides = allSlides.filter((slide) => !slide.hidden);

  const setActive = (index) => {
    if (!slides.length) return;
    activeIndex = (index + slides.length) % slides.length;
    const activeGalleryIndex = slides[activeIndex].dataset.galleryIndex;
    allDots.forEach((dot) => {
      const active = dot.dataset.galleryDot === activeGalleryIndex;
      dot.classList.toggle('is-active', active);
      dot.setAttribute('aria-current', String(active));
    });
  };

  const goTo = (index, smooth = true) => {
    if (!slides.length) return;
    const target = (index + slides.length) % slides.length;
    track.scrollTo({ left: slides[target].offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
    setActive(target);
  };

  const refreshVisibleMedia = () => {
    slides = allSlides.filter((slide) => !slide.hidden);
    gallery.classList.toggle('product-gallery--single', slides.length < 2);
    controls?.toggleAttribute('hidden', slides.length < 2);
  };

  const setMediaGroup = (group, moveToVariantImage = false) => {
    if (!gallery.hasAttribute('data-variant-media-gallery') || !group) return;

    allSlides.forEach((slide) => {
      const mediaGroup = slide.dataset.mediaGroup;
      slide.hidden = mediaGroup !== 'shared' && mediaGroup !== group;
    });
    allDots.forEach((dot) => {
      const mediaGroup = dot.dataset.mediaGroup;
      dot.hidden = mediaGroup !== 'shared' && mediaGroup !== group;
    });

    refreshVisibleMedia();
    window.requestAnimationFrame(() => goTo(moveToVariantImage && slides.length > 1 ? 1 : 0, false));
  };

  gallery.setVariantMediaGroup = setMediaGroup;

  previous?.addEventListener('click', () => goTo(activeIndex - 1));
  next?.addEventListener('click', () => goTo(activeIndex + 1));
  allDots.forEach((dot) => dot.addEventListener('click', () => {
    const target = slides.findIndex((slide) => slide.dataset.galleryIndex === dot.dataset.galleryDot);
    if (target >= 0) goTo(target);
  }));

  track.addEventListener('scroll', () => {
    window.clearTimeout(scrollTimer);
    scrollTimer = window.setTimeout(() => {
      const nearest = slides.reduce((best, slide, index) => {
        const distance = Math.abs(slide.offsetLeft - track.scrollLeft);
        return distance < best.distance ? { index, distance } : best;
      }, { index: 0, distance: Infinity });
      setActive(nearest.index);
    }, 80);
  }, { passive: true });

  refreshVisibleMedia();
  setActive(0);
};

document.querySelectorAll('[data-product-gallery]').forEach(initializeProductGallery);

// Shopify's theme editor can replace the mobile preview section without a full
// page reload. Reinitialize the carousel whenever that happens.
document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll('[data-product-gallery]').forEach(initializeProductGallery);
});

document.querySelectorAll('[data-featured-carousel]').forEach((carousel) => {
  const track = carousel.querySelector('[data-featured-track]');
  const slides = [...carousel.querySelectorAll('[data-featured-slide]')];
  const controls = carousel.querySelector('[data-featured-controls]');
  const previous = carousel.querySelector('[data-featured-prev]');
  const next = carousel.querySelector('[data-featured-next]');
  const current = carousel.querySelector('[data-featured-current]');
  const total = carousel.querySelector('[data-featured-total]');
  if (!track || !slides.length) return;

  if (total) total.textContent = String(slides.length);
  if (slides.length < 2) {
    controls?.setAttribute('hidden', '');
    return;
  }

  let activeIndex = 0;
  let scrollTimer;

  const setActive = (index) => {
    activeIndex = Math.max(0, Math.min(index, slides.length - 1));
    if (current) current.textContent = String(activeIndex + 1);
    previous?.toggleAttribute('disabled', activeIndex === 0);
    next?.toggleAttribute('disabled', activeIndex === slides.length - 1);
  };

  const goTo = (index) => {
    const target = Math.max(0, Math.min(index, slides.length - 1));
    track.scrollTo({ left: slides[target].offsetLeft - track.offsetLeft, behavior: 'smooth' });
    setActive(target);
  };

  previous?.addEventListener('click', () => goTo(activeIndex - 1));
  next?.addEventListener('click', () => goTo(activeIndex + 1));
  track.addEventListener('scroll', () => {
    window.clearTimeout(scrollTimer);
    scrollTimer = window.setTimeout(() => {
      const nearest = slides.reduce((best, slide, index) => {
        const distance = Math.abs((slide.offsetLeft - track.offsetLeft) - track.scrollLeft);
        return distance < best.distance ? { index, distance } : best;
      }, { index: 0, distance: Infinity });
      setActive(nearest.index);
    }, 80);
  }, { passive: true });

  setActive(0);
});

// Upgrade any legacy Shopify variant dropdown that remains in cached or alternate
// product markup to the same button picker used by the main product section.
document.querySelectorAll('.product-form select[name="id"]').forEach((select) => {
  if (select.closest('.variant-picker')) return;

  const fieldset = document.createElement('fieldset');
  fieldset.className = 'product-form__row variant-picker';

  const legend = document.createElement('legend');
  const existingLabel = select.previousElementSibling;
  legend.textContent = existingLabel?.textContent?.trim() || 'Choose option';
  fieldset.appendChild(legend);

  const buttons = document.createElement('div');
  buttons.className = 'variant-picker__buttons';

  [...select.options].forEach((option) => {
    const wrapper = document.createElement('label');
    wrapper.className = `variant-picker__button${option.disabled ? ' is-disabled' : ''}`;

    const input = document.createElement('input');
    input.className = 'variant-picker__input';
    input.type = 'radio';
    input.name = 'id';
    input.value = option.value;
    input.checked = option.selected;
    input.disabled = option.disabled;
    input.dataset.variantInput = '';

    const label = document.createElement('span');
    label.className = 'variant-picker__label';
    label.textContent = option.textContent.split(' — ')[0].trim();

    input.addEventListener('change', () => {
      if (!input.checked) return;
      select.value = input.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    });

    wrapper.append(input, label);
    buttons.appendChild(wrapper);
  });

  fieldset.appendChild(buttons);
  select.disabled = true;
  select.hidden = true;
  existingLabel?.setAttribute('hidden', '');
  select.parentElement?.appendChild(fieldset);
});

// Delegation keeps variant switching working in both the live mobile storefront
// and Shopify's dynamically replaced mobile theme-editor preview.
document.addEventListener('change', (event) => {
  if (!(event.target instanceof Element)) return;
  const input = event.target.closest('[data-variant-input]');
  if (!input || !input.checked) return;

  const productSection = input.closest('.main-product');
  const price = productSection?.querySelector('[data-product-price]');
  const gallery = productSection?.querySelector('[data-product-gallery]');

  if (price && input.dataset.variantPrice) price.textContent = input.dataset.variantPrice;
  if (gallery && input.dataset.variantMediaGroup) {
    initializeProductGallery(gallery);
    gallery.setVariantMediaGroup?.(input.dataset.variantMediaGroup, true);
  }
});

let quickAddNoticeTimer;

const showQuickAddNotice = (productTitle) => {
  const shopRoot = window.Shopify?.routes?.root || '/';
  let notice = document.querySelector('[data-cart-notice]');

  if (!notice) {
    notice = document.createElement('div');
    notice.className = 'cart-notice';
    notice.dataset.cartNotice = '';
    notice.setAttribute('role', 'status');
    notice.setAttribute('aria-live', 'polite');
    notice.innerHTML = `
      <div class="cart-notice__message">
        <span class="cart-notice__check" aria-hidden="true">✓</span>
        <div>
          <strong>ADDED TO YOUR BAG</strong>
          <span data-cart-notice-title></span>
        </div>
      </div>
      <div class="cart-notice__actions">
        <button type="button" data-cart-notice-close>KEEP SHOPPING</button>
        <a href="${shopRoot}cart">VIEW BAG <span aria-hidden="true">→</span></a>
      </div>
    `;
    document.body.appendChild(notice);
    notice.querySelector('[data-cart-notice-close]').addEventListener('click', () => {
      notice.classList.remove('is-visible');
    });
  }

  notice.querySelector('[data-cart-notice-title]').textContent = productTitle || 'Your mask';
  clearTimeout(quickAddNoticeTimer);
  requestAnimationFrame(() => notice.classList.add('is-visible'));
  quickAddNoticeTimer = setTimeout(() => notice.classList.remove('is-visible'), 6000);
};

const refreshCartCount = async () => {
  const shopRoot = window.Shopify?.routes?.root || '/';
  const response = await fetch(`${shopRoot}cart.js`, { headers: { Accept: 'application/json' } });
  if (!response.ok) return null;
  const cart = await response.json();

  document.querySelectorAll('[data-cart-count]').forEach((count) => {
    count.textContent = cart.item_count;
    count.hidden = cart.item_count === 0;
  });
  document.querySelectorAll('[data-cart-link]').forEach((link) => {
    link.setAttribute('aria-label', `Bag with ${cart.item_count} ${cart.item_count === 1 ? 'item' : 'items'}`);
  });
  return cart;
};

const closeProductCartPanel = () => {
  document.querySelector('[data-product-cart-panel]')?.classList.remove('is-visible');
  document.body.classList.remove('cart-panel-open');
};

const showProductCartPanel = ({ item, productTitle, variantTitle, price, cartCount }) => {
  const shopRoot = window.Shopify?.routes?.root || '/';
  let panel = document.querySelector('[data-product-cart-panel]');

  if (!panel) {
    panel = document.createElement('div');
    panel.className = 'product-cart-panel';
    panel.dataset.productCartPanel = '';
    panel.innerHTML = `
      <button class="product-cart-panel__backdrop" type="button" data-product-cart-close aria-label="Close bag confirmation"></button>
      <aside class="product-cart-panel__drawer" role="dialog" aria-modal="true" aria-labelledby="product-cart-panel-title">
        <button class="product-cart-panel__close" type="button" data-product-cart-close aria-label="Close bag confirmation">×</button>
        <p class="eyebrow">ADDED TO YOUR BAG</p>
        <h2 id="product-cart-panel-title">READY WHEN YOU ARE.</h2>
        <div class="product-cart-panel__item">
          <div class="product-cart-panel__media">
            <img data-product-cart-image alt="" hidden>
          </div>
          <div class="product-cart-panel__details">
            <strong data-product-cart-title></strong>
            <span data-product-cart-variant></span>
            <span data-product-cart-price></span>
          </div>
        </div>
        <p class="product-cart-panel__count" data-product-cart-count></p>
        <div class="product-cart-panel__actions">
          <button type="button" data-product-cart-close>CONTINUE SHOPPING</button>
          <a href="${shopRoot}cart">VIEW BAG</a>
          <a class="product-cart-panel__checkout" href="${shopRoot}checkout">CHECKOUT <span aria-hidden="true">→</span></a>
        </div>
      </aside>
    `;
    document.body.appendChild(panel);
    panel.querySelectorAll('[data-product-cart-close]').forEach((close) => {
      close.addEventListener('click', closeProductCartPanel);
    });
  }

  document.querySelector('[data-cart-notice]')?.classList.remove('is-visible');

  const image = panel.querySelector('[data-product-cart-image]');
  const imageUrl = item?.featured_image?.url || item?.image;
  if (image && imageUrl) {
    image.src = imageUrl;
    image.alt = item?.featured_image?.alt || productTitle || 'Added product';
    image.hidden = false;
  } else if (image) {
    image.removeAttribute('src');
    image.hidden = true;
  }

  panel.querySelector('[data-product-cart-title]').textContent = item?.product_title || productTitle || 'Your mask';
  const variant = panel.querySelector('[data-product-cart-variant]');
  const resolvedVariant = item?.variant_title || variantTitle;
  variant.textContent = resolvedVariant && resolvedVariant !== 'Default Title' ? resolvedVariant : '';
  variant.hidden = !variant.textContent;
  panel.querySelector('[data-product-cart-price]').textContent = price || '';
  panel.querySelector('[data-product-cart-count]').textContent = cartCount
    ? `YOUR BAG NOW HAS ${cartCount} ${cartCount === 1 ? 'ITEM' : 'ITEMS'}`
    : 'YOUR BAG HAS BEEN UPDATED';

  document.body.classList.add('cart-panel-open');
  requestAnimationFrame(() => panel.classList.add('is-visible'));
  panel.querySelector('.product-cart-panel__close')?.focus();
};

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') closeProductCartPanel();
});

// Product-page Add to Bag stays on the product page and opens a useful bag panel.
document.addEventListener('submit', async (event) => {
  if (!(event.target instanceof Element)) return;
  const form = event.target.closest('.product-form');
  if (!form) return;

  event.preventDefault();
  const button = form.querySelector('[type="submit"]');
  if (!button || button.disabled) return;

  const original = button.innerHTML;
  const productInfo = form.closest('.product-info');
  const productTitle = productInfo?.querySelector('h1')?.textContent?.trim();
  const variantTitle = form.querySelector('[data-variant-input]:checked')
    ?.closest('.variant-picker__button')
    ?.querySelector('.variant-picker__label')
    ?.textContent
    ?.trim();
  const price = productInfo?.querySelector('[data-product-price]')?.textContent?.trim();

  button.textContent = 'ADDING…';
  button.disabled = true;

  try {
    const shopRoot = window.Shopify?.routes?.root || '/';
    const response = await fetch(`${shopRoot}cart/add.js`, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    });
    if (!response.ok) throw new Error('Unable to add item');

    const item = await response.json();
    const cart = await refreshCartCount().catch(() => null);
    button.textContent = 'ADDED ✓';
    showProductCartPanel({ item, productTitle, variantTitle, price, cartCount: cart?.item_count });

    setTimeout(() => {
      button.innerHTML = original;
      button.disabled = false;
    }, 1600);
  } catch (error) {
    button.textContent = 'TRY AGAIN';
    button.disabled = false;
  }
});

// Delegated submission also works after Shopify reloads a section in the theme editor.
document.addEventListener('submit', async (event) => {
  if (!(event.target instanceof Element)) return;
  const form = event.target.closest('.quick-add-form');
  if (!form) return;

  event.preventDefault();
  const button = form.querySelector('button');
  if (!button || button.disabled) return;

  const original = button.innerHTML;
  const productTitle = form.closest('.product-card')?.querySelector('.product-card__title')?.textContent?.trim();
  button.textContent = 'ADDING…';
  button.disabled = true;

  try {
    const shopRoot = window.Shopify?.routes?.root || '/';
    const response = await fetch(`${shopRoot}cart/add.js`, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    });
    if (!response.ok) throw new Error('Unable to add item');

    button.textContent = 'ADDED ✓';
    refreshCartCount().catch(() => {});
    showQuickAddNotice(productTitle);
    setTimeout(() => {
      button.innerHTML = original;
      button.disabled = false;
    }, 1600);
  } catch (error) {
    button.textContent = 'TRY AGAIN';
    button.disabled = false;
  }
});

const initializeCartForm = (form) => {
  if (form.dataset.cartReady === 'true') return;
  form.dataset.cartReady = 'true';

  const updateButton = form.querySelector('[data-cart-update]');
  let updateTimer;

  const scheduleUpdate = () => {
    clearTimeout(updateTimer);
    updateTimer = setTimeout(() => {
      form.classList.add('is-updating');
      if (typeof form.requestSubmit === 'function' && updateButton) {
        form.requestSubmit(updateButton);
      } else if (updateButton) {
        updateButton.click();
      }
    }, 450);
  };

  form.querySelectorAll('[data-quantity-adjust]').forEach((button) => {
    button.addEventListener('click', () => {
      const quantity = button.closest('.cart-quantity')?.querySelector('[data-cart-quantity]');
      if (!quantity) return;

      const minimum = Number.parseInt(quantity.min || '0', 10);
      const current = Number.parseInt(quantity.value || '0', 10);
      const adjustment = Number.parseInt(button.dataset.quantityAdjust || '0', 10);
      quantity.value = String(Math.max(minimum, current + adjustment));
      scheduleUpdate();
    });
  });

  form.querySelectorAll('[data-cart-quantity]').forEach((quantity) => {
    quantity.addEventListener('change', scheduleUpdate);
  });
};

document.querySelectorAll('[data-cart-form]').forEach(initializeCartForm);
document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll('[data-cart-form]').forEach(initializeCartForm);
});
